module.exports = __webpack_public_path__ + "static/media/DASH_M.228fa331.mov";